<div id="home">
  <app-hero></app-hero>
</div>
<div id="organization">
  <app-about></app-about>
</div>
<div id="abbs">
  <app-abbs></app-abbs>
</div>
<div id="prinsip">
  <app-prinsip></app-prinsip>
</div>
<div id="catha">
  <app-catha></app-catha>
</div>
<div id="yearly">
  <section class="catha bg-white section-padding px-3 px-sm-0">
    <div class="container">
      <h2 class="section-title text-center text-primary-1 mb-5">Linimasa ICCN</h2>

      <img src="assets/img/others/linimasa.png" alt="linimasa" class="img-fluid mb-5">

      <h2 class="section-title text-center text-primary-1 mb-5">Program Tahunan ICCN</h2>
      <div class="row">
        <div class="col-md-12 mb-4">
          <h4>1. Rapat Koordinasi Nasional (Rakornas) ICCN</h4>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <a href="#" class="stretched-link">
                <img src="assets/img/illustration/rakornas.png" alt="Ilustrasi Rakornas" class="img-fluid" width="200px">
                <h5 class="mb-0">
                  Indonesia Creative Cities Conference (ICCC1),
                  <br> Surakarta, 22-25 Oktober 2015
                </h5>
              </a>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <a href="#" class="stretched-link">
                <img src="assets/img/illustration/rakornas.png" alt="Ilustrasi Rakornas" class="img-fluid" width="200px">
                <h5 class="mb-0">
                  Indonesia Creative Cities Conference (ICCC2),
                  <br> Malang, 30 Maret 2016
                </h5>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <a href="#" class="stretched-link">
                <img src="assets/img/illustration/rakornas.png" alt="Ilustrasi Rakornas" class="img-fluid" width="200px">
                <h5 class="mb-0">
                  Indonesia Creative Cities Conference (ICCC3),
                  <br> Makassar, 6-10 September 2017
                </h5>
              </a>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <a href="#" class="stretched-link">
                <img src="assets/img/illustration/rakornas.png" alt="Ilustrasi Rakornas" class="img-fluid" width="200px">
                <h5 class="mb-0">
                  Rapat Koordinasi Nasional (Rakornas) 2018,
                  <br> Padang, 4-6 Mei 2018
                </h5>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="row align-items-center mb-5">
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <a href="#" class="stretched-link">
                <img src="assets/img/illustration/rakornas.png" alt="Ilustrasi Rakornas" class="img-fluid" width="200px">
                <h5 class="mb-0">
                  Rapat Koordinasi Nasional (Rakornas) 2019,
                  <br> Surabaya, 28-30 Mei 2019
                </h5>
              </a>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <a href="#" class="stretched-link">
                <img src="assets/img/illustration/rakornas.png" alt="Ilustrasi Rakornas" class="img-fluid" width="200px">
                <h5 class="mb-0">
                  Rapat Koordinasi Nasional (Rakornas) 2020
                  <br> Banyuwangi, 5-6 November 2020
                </h5>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="row align-items-center mb-5">
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <a href="#" class="stretched-link">
                <img src="assets/img/illustration/rakornas.png" alt="Ilustrasi Rakornas" class="img-fluid" width="200px">
                <h5 class="mb-0">
                  Rapat Koordinasi Nasional (Rakornas) 2021                  <br> Pontianak, 20-24 Oktober 2021
                </h5>
              </a>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <a href="#" class="stretched-link">
                <img src="assets/img/illustration/rakornas.png" alt="Ilustrasi Rakornas" class="img-fluid" width="200px">
                <h5 class="mb-0">
                  Rapat Koordinasi Nasional (Rakornas) 2022
                  <br> Labuan Bajo
                </h5>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 mb-4">
          <h4>2. Indonesia Creative Cities Festival (ICCF)</h4>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <a href="#" class="stretched-link">
                <img src="assets/img/illustration/iccf-new.png" alt="Ilustrasi ICCF" class="img-fluid" width="200px">
                <h5 class="mb-0">Indonesia Creative Cities Festival (ICCF) 2018 + ICCC4, <br> Yogyakarta, 15-20 Oktober 2018
                </h5>
              </a>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <a href="#" class="stretched-link">
                <img src="assets/img/illustration/iccf-new.png" alt="Ilustrasi ICCF" class="img-fluid" width="200px">
                <h5 class="mb-0">Indonesia Creative Cities Festival (ICCF) 2019 + ICCC5, <br>Ternate, 2-7 September 2019 
                </h5>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <a href="#" class="stretched-link">
                <img src="assets/img/illustration/iccf-new.png" alt="Ilustrasi ICCF" class="img-fluid" width="200px">
                <h5 class="mb-0">Indonesia Creative Cities Festival (ICCF) 2020, <br> Denpansar-Karangasem, 26-28 November 2020 </h5>
              </a>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <a href="#" class="stretched-link">
                <img src="assets/img/illustration/iccf-new.png" alt="Ilustrasi ICCF" class="img-fluid" width="200px">
                <h5 class="mb-0">Indonesia Creative Cities Festival (ICCF) 2022, <br>Pekanbaru-Siak, 26-29 November 2021</h5>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<div id="kemitraan">
  <section class="catha bg-grey section-padding px-3 px-sm-0">
    <div class="container">
      <h2 class="section-title text-center text-primary-1 mb-5">Program Kemitraan ICCN</h2>
      <div class="row align-items-center">
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <a href="#" class="stretched-link">
                <h5 class="mb-0">JELO (Jenama Lokal) bekerjasa sama Kementrian Koperasi dan UKM</h5>
              </a>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <a href="#" class="stretched-link">
                <h5 class="mb-0">Hyundai Start-Up Challenge</h5>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <a href="#" class="stretched-link">
                <h5 class="mb-0">BAMO (Bootcamp Accelerator for Mayor Office)</h5>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<!-- <div id="kemitraan">
  <section class="catha bg-white section-padding px-3 px-sm-0">
    <div class="container">
      <h2 class="section-title text-center text-primary-1 mb-5">Program Kedeputian ICCN</h2>
      <div class="row align-items-center">
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <a href="#" class="stretched-link">
                <h5 class="mb-0">
                  Deputi: <br>
                  Indonesia Creative Store
                </h5>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div> -->

<div id="kemanusiaan">
  <section class="catha bg-grey section-padding px-3 px-sm-0">
    <div class="container">
      <h2 class="section-title text-center text-primary-1 mb-5">Program Kemanusiaan ICCN</h2>
      <div class="row justify-content-center align-items-center">
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <a href="http://fightcovid19.iccn.or.id/" class="stretched-link">
                <h5 class="mb-0">
                  Aksi bersama bantu sesama: <br>
                  Fight COVID-19
                </h5>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<div id="store">
  <section class="catha bg-grey section-padding px-3 px-sm-0">
    <div class="container">
      <h2 class="section-title text-center text-primary-1 mb-5">Belanja Barang Indonesia</h2>
      <div class="row justify-content-center align-items-center">
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <a href="https://ics.iccn.or.id/home" class="stretched-link">
                <img src="assets/img/logo/ics.png" alt="" class="img-fluid mb-4" width="200px">
                <h5 class="mb-0">
                  Indonesia Creative Store <br> (ICS)
                </h5>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<div id="media">
  <section class="catha bg-white section-padding px-3 px-sm-0">
    <div class="container">
      <h2 class="section-title text-center text-primary-1 mb-5">ICCN Media</h2>
      <div class="row align-items-center">
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <a href="#" class="stretched-link">
                <h5 class="mb-0">
                  Press Release ICCN
                </h5>
              </a>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <a href="#" class="stretched-link">
                <h5 class="mb-0">
                  Kabar Jejaring ICCN
                </h5>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <a href="https://www.youtube.com/channel/UCBG8-I_qHRQxphOBowSOnvw" class="stretched-link">
                <h5 class="mb-0">
                  Youtube ICCN Media
                </h5>
              </a>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <a href="https://www.instagram.com/iccnmedia" class="stretched-link">
                <h5 class="mb-0">
                  Instagram ICCN Media
                </h5>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <a href="#" class="stretched-link">
                <h5 class="mb-0">
                  Facebook ICCN Media
                </h5>
              </a>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <a href="#" class="stretched-link">
                <h5 class="mb-0">
                  Twitter ICCN Media
                </h5>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<div id="learning">
  <app-learning></app-learning>
</div>
<!-- <div id="organization">
  <app-organization></app-organization>
</div> -->
<div id="highlight">
  <app-highlight></app-highlight>
</div>
<!-- <div id="events">
  <app-events></app-events>
</div> -->
<div id="news">
  <app-news></app-news>
</div>

<div id="collaboration">
  <section class="bg-grey section-padding px-3 px-sm-0">
    <div class="container">
      <h2 class="section-title text-center text-primary-1 mb-5">Kolaborasi</h2>
      <div class="row align-items-center">
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <iframe width="100%" height="315" src="https://www.youtube.com/embed/FG_Yn1GpEL4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <iframe width="100%" height="315" src="https://www.youtube.com/embed/UNf4YaQDvu8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <iframe width="100%" height="315" src="https://www.youtube.com/embed/OpgcE6fUHcw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <iframe width="100%" height="315" src="https://www.youtube.com/embed/5ZTNdznINjY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card mb-3">
            <div class="card-body text-center">
              <iframe width="100%" height="315" src="https://www.youtube.com/embed/8Z0lyGjx1JA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<div id="contact">
  <app-contact></app-contact>
</div>
